import r from "./identity.js";
import o from "./_overRest.js";
import i from "./_setToString.js";
var s = r, a = o, m = i;
function n(t, e) {
  return m(a(t, e, s), t + "");
}
var R = n;
export {
  R as default
};
//# sourceMappingURL=_baseRest.js.map
